import { getMapObjectVisualDefinition, reportMapObjectImageLoadFailure } from '../../content/objectVisualRegistry';

interface ObjectImageRecord {
  image: HTMLImageElement;
  loaded: boolean;
  failed: boolean;
}

const objectImageCache = new Map<string, ObjectImageRecord>();
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function getMapObjectImage(objectId: string): HTMLImageElement | null {
  const existing = objectImageCache.get(objectId);
  if (existing) {
    return existing.loaded && !existing.failed ? existing.image : null;
  }

  const definition = getMapObjectVisualDefinition(objectId);
  if (!definition) {
    return null;
  }

  const image = new Image();
  const record: ObjectImageRecord = {
    image,
    loaded: false,
    failed: false,
  };

  image.onload = () => {
    record.loaded = true;
    notifyListeners();
  };
  image.onerror = () => {
    record.failed = true;
    reportMapObjectImageLoadFailure(objectId, definition.imagePath);
  };
  image.src = definition.imagePath;
  objectImageCache.set(objectId, record);
  return null;
}

export function invalidateMapObjectImage(objectId?: string): void {
  if (typeof objectId === 'string') {
    objectImageCache.delete(objectId);
  } else {
    objectImageCache.clear();
  }
  notifyListeners();
}

export function subscribeToMapObjectImageUpdates(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
